'use strict'
/* eslint-env browser */

/* eslint-disable no-undef, no-use-before-define, new-cap */
module.exports = function (content, workerConstructor, workerOptions, url, args) {
  if(typeof window !== 'undefined') {
    content = `
      const worker = self;
      worker.browser = true;
      worker.args=${JSON.stringify(args.slice(1))};
      worker.debug = function(...args){worker.postMessage({_owner_action: 'debug', data: args})};
      worker.info = function(...args){worker.postMessage({_owner_action: 'info', data: args})};
      worker.warn = function(...args){worker.postMessage({_owner_action: 'warn', data: args})};
      worker.error = function(...args){worker.postMessage({_owner_action: 'error', data: args})};
      worker.publish = function(target,action,params){worker.postMessage({_owner_action: 'publish', target, action, params})};
      worker.publishAs = function(sender,target,action,params){worker.postMessage({_owner_action: 'publishAs', sender, target, action, params})};
      worker.terminate = function(err){worker.postMessage({_owner_action: 'terminate', err})};
    ` + content
    let worker = null
    try{
      let blob
      try{
        // New API
        blob = new Blob([content])
      }catch(e) {
        // BlobBuilder = Deprecated, but widely implemented
        const myBlobBuilder = BlobBuilder || WebKitBlobBuilder || MozBlobBuilder || MSBlobBuilder
        blob = new myBlobBuilder()
        blob.append(content)
        blob = blob.getBlob()
      }

      const myURL = URL || webkitURL
      const objectURL = myURL.createObjectURL(blob)
      worker = new Worker(objectURL, workerOptions)
      myURL.revokeObjectURL(objectURL)
    }catch(e) {
      worker = new Worker('data:application/javascript,'.concat(encodeURIComponent(content)), workerOptions)
    }
    const worker_encapsulated = {
      worker,
      postMessage: worker.postMessage.bind(worker),
      terminate: (err)=>{
        worker.terminate()
        worker_encapsulated.terminated = true
        if(typeof worker_encapsulated.onexit==='function') {
          try{ worker_encapsulated.onexit(err) }catch(e) {}
        }
      },
    }
    worker.onmessage = (event)=>{
      const data = event && typeof (event)==='object' ? event.data : null
      if(data && typeof (data)==='object' && data._owner_action) {
        const listener = args[0]
        try{
          if(data._owner_action==='debug' && listener) listener.debug.apply(listener, data.data)
          else if(data._owner_action==='info' && listener) listener.info.apply(listener, data.data)
          else if(data._owner_action==='warn' && listener) listener.warn.apply(listener, data.data)
          else if(data._owner_action==='error' && listener) listener.error.apply(listener, data.data)
          else if(data._owner_action==='publish' && listener) listener.publish(data.target, data.action, data.params)
          else if(data._owner_action==='publishAs' && listener) listener.publishAs(data.sender, data.target, data.action, data.params)
          else if(data._owner_action==='terminate') worker_encapsulated.terminate(data.err)
        }catch(e) {}
      }else if(worker_encapsulated.onmessage) {
        worker_encapsulated.onmessage(event)
      }
    }
    worker.onerror = (err)=>{
      console.error_orig(err)
      if(worker_encapsulated.onerror) return worker_encapsulated.onerror({ data })
      const listener = args[0]
      if(listener) listener.error(err)
      else console.error(err)
    }
    return worker_encapsulated
  }else if(typeof global !== 'undefined') {
    const Worker = require('worker_threads').Worker
    content =
    `
      const parentPort = require('worker_threads').parentPort;
      const worker = {
        postMessage: parentPort.postMessage.bind(parentPort),
        args: ${JSON.stringify(args.slice(1))}
      };
      worker.browser = false;
      worker.debug = function(...args){worker.postMessage({_owner_action: 'debug', data: args})};
      worker.info = function(...args){worker.postMessage({_owner_action: 'info', data: args})};
      worker.warn = function(...args){worker.postMessage({_owner_action: 'warn', data: args})};
      worker.error = function(...args){worker.postMessage({_owner_action: 'error', data: args})};
      worker.terminate = function(){ process.exit() }
      worker.publish = function(target,action,params){worker.postMessage({_owner_action: 'publish', target, action, params})};
      worker.publishAs = function(sender,target,action,params){worker.postMessage({_owner_action: 'publishAs', sender, target, action, params})};
      parentPort.on("message", function(data){
        if(worker.onmessage) worker.onmessage({data})
      });
      process.on('uncaughtException', async function(err) {
        worker.error('Worker error:', err)
        process.exit(1)
      });
    ` +
    content
    const worker = new Worker(content, { eval: true })
    const worker_encapsulated = {
      worker,
      postMessage: worker.postMessage.bind(worker),
      terminate: (err)=>{
        if(!worker_encapsulated.terminated) {
          worker_encapsulated.terminated = true
          worker.terminate()
          if(typeof worker_encapsulated.onexit==='function') {
            try{ worker_encapsulated.onexit(err) }catch(e) {}
          }
        }
      },
    }
    worker.on('message', (data)=>{
      if(data && typeof (data)==='object' && data._owner_action) {
        const listener = args[0]
        try{
          if(data._owner_action==='debug' && listener) listener.debug.apply(listener, data.data)
          else if(data._owner_action==='info' && listener) listener.info.apply(listener, data.data)
          else if(data._owner_action==='warn' && listener) listener.warn.apply(listener, data.data)
          else if(data._owner_action==='error' && listener) listener.error.apply(listener, data.data)
          else if(data._owner_action==='publish' && listener) listener.publish(data.target, data.action, data.params)
          else if(data._owner_action==='publishAs' && listener) listener.publishAs(data.sender, data.target, data.action, data.params)
          else if(data._owner_action==='terminate') worker_encapsulated.terminate(data.err)
        }catch(e) {}
      }else if(worker_encapsulated.onmessage) {
        worker_encapsulated.onmessage({ data })
      }
    })
    worker.on('error', (err)=>{
      if(worker_encapsulated.onerror) return worker_encapsulated.onerror({ data })
      const listener = args[0]
      if(listener) listener.error(err)
      else console.error(err)
    })
    worker.on('exit', (code)=>{
      if(!worker_encapsulated.terminated) {
        worker_encapsulated.terminated = true
        if(typeof worker_encapsulated.onexit==='function') {
          try{ worker_encapsulated.onexit(code) }catch(e) {}
        }else{
          worker.emit('error', 'Worker exited with code '+code)
        }
      }
    })
    return worker_encapsulated
  }
}
